import {shrinker} from "./shrinker";

/**
 * A server's per-field error map, either as the rejected value itself or as the `cause` of the
 * `Error` a refused mutation rejects with. Null for any other rejection.
 */
export const getFieldErrors = (maybeError) => {
  const value = maybeError instanceof Error ? maybeError.cause : maybeError;
  return typeof value === "object" && value !== null && !(value instanceof Error) ? value : null;
};

export const errorToString = (maybeError, fallback) => {
  if (!maybeError) return "Unknown error";
  if (typeof maybeError === "string") return maybeError;
  if (maybeError.message) return errorToString(maybeError.message);
  if (maybeError.error) return errorToString(maybeError.error);
  if (maybeError.payload) return errorToString(maybeError.payload);
  console.error("Couldn't interpret error", maybeError);
  try {
    return shrinker(JSON.stringify(maybeError), 60);
  } catch {
    return fallback !== undefined ? fallback : "Unknown error";
  }
};
